/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 16:20:35
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-21 10:12:06
 */
import { getElementsByPath } from '@antv/g2/lib/interaction/action/util'
import { notification, Space, Switch, TableColumnType } from 'antd'
import React, { ReactElement, useState } from 'react'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { Dimen } from '../../models/dimen'
import { getGenderName } from '../../models/user'
import femaleHead from '../images/female.png'
import maleHead from '../images/male.png'

type ActionType = 'edit' | 'stateEdit' | 'typeEdit'

export const columns = (
  onClick: (action: ActionType, v: any, state?: any) => void,
  onlineClick: (action: ActionType, v: any, state?: any, type?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {

  return [
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '工号',
      dataIndex: 'jobNumber',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.jobNumber ? r.jobNumber : '-'
      },
    },
    {
      title: '医生头像',
      dataIndex: 'headPhoto',
      align: 'center',
      ellipsis: true,
      render: function ShowActions(_, r) {
        return r.headPhoto ? (
          <img
            src={r.headPhoto}
            alt=''
            style={{ width: '30px', height: '30px', borderRadius: '50%' }}
          ></img>
        ) : r.sex == 2 ? (
          <img
            src={femaleHead}
            alt=''
            style={{ width: '30px', height: '30px', borderRadius: '50%' }}
          ></img>
        ) : (
          <img
            src={maleHead}
            alt=''
            style={{ width: '30px', height: '30px', borderRadius: '50%' }}
          ></img>
        )
      },
    },
    {
      title: '医生名称',
      dataIndex: 'name',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.name ? r.name : '-'
      },
    },
    {
      title: '医生职称',
      dataIndex: 'jobTitle',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.selfTitle ? r.selfTitle : r.jobTitle
      },
    },

    {
      title: '所属科室',
      dataIndex: 'hisDepartmentName',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.hisDepartmentName ? r.hisDepartmentName : '-'
      },
    },
    {
      title: '挂号费',
      dataIndex: 'selfFee',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.selfFee ? r.selfFee : '-'
      },
    },
    {
      title: '门诊时间',
      dataIndex: 'selfTime',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.selfTime ? r.selfTime : '-'
      },
    },
    {
      title: '医生简介',
      dataIndex: 'intro',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.intro ? r.intro : '-'
      },
    },
    {
      title: '医生主治',
      dataIndex: 'majorFunction',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.majorFunction ? r.majorFunction : '-'
      },
    },
    {
      title: '展示在小程序',
      dataIndex: '',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function UserSettings(_, d): ReactElement {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {d.disabledFlg == 0 ? '展示' : d.disabledFlg == 1 ? '不展示' : ''}

            <Switch
              checked={Boolean(d.disabledFlg == 0 ? true : false)}
              style={{ marginLeft: '10px' }}
              onChange={(e) => {
                onClick('stateEdit', d, e == false ? 1 : '0')
              }}
            />
          </div>
        )
      },
    },
    // {
    //   title: '是否开启在线问诊',
    //   dataIndex: '',
    //   align: 'center',
    //   width: '10rem',
    //   ellipsis: true,
    //   render: function UserSettings(_, d): ReactElement {
    //     return (
    //       <div
    //         style={{
    //           display: 'flex',
    //           justifyContent: 'center',
    //           alignItems: 'center',
    //         }}
    //       >
    //         {d.isOnline == 1 ? '展示' : d.isOnline == 0 ? '不展示' : ''}

    //         <Switch
    //           checked={Boolean(d.isOnline == 0 ? false : true)}
    //           style={{ marginLeft: '10px' }}
    //           onChange={(e) => {
    //             onlineClick('stateEdit', d, e == false ? '0' : 1)
    //           }}
    //         />
    //       </div>
    //     )
    //   },
    // },
    {
      title: '在线复诊',
      dataIndex: '',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function UserSettings(_, d): ReactElement {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {d.isOnlineFollowUpVisits == 1
              ? '开启'
              : d.isOnlineFollowUpVisits == 0
              ? '关闭'
              : ''}

            <Switch
              checked={Boolean(d.isOnlineFollowUpVisits == 0 ? false : true)}
              style={{ marginLeft: '10px' }}
              onChange={(e: any) => {
                if (e && !(d?.onlineFollowUpVisitsFee)?.toString()) {
                  notification.info({ message: '请先填写复诊费用' })
                } else {
                  onlineClick('typeEdit', d, e == false ? '0' : 1, '1')
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: '图文咨询',
      dataIndex: '',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function UserSettings(_, d): ReactElement {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {d.isGraphicConsultation == 1
              ? '开启'
              : d.isGraphicConsultation == 0
              ? '关闭'
              : ''}

            <Switch
              checked={Boolean(d.isGraphicConsultation == 0 ? false : true)}
              style={{ marginLeft: '10px' }}
              onChange={(e: any) => {
                if (e && !(d?.graphicConsultationFee)?.toString()) {
                  notification.info({ message: '请先填写图文咨询费用' })
                } else {
                  onlineClick('typeEdit', d, e == false ? '0' : 1, '2')
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: '电话咨询',
      dataIndex: '',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function UserSettings(_, d): ReactElement {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {d.isTelephoneConsultation == 1
              ? '开启'
              : d.isTelephoneConsultation == 0
              ? '关闭'
              : ''}

            <Switch
              checked={Boolean(d.isTelephoneConsultation == 0 ? false : true)}
              style={{ marginLeft: '10px' }}
              onChange={(e: any) => {
                if (e && !(d?.telephoneConsultationFee)?.toString()) {
                  notification.info({ message: '请先填写电话咨询费用' })
                } else {
                  onlineClick('typeEdit', d, e == false ? '0' : 1, '3')
                }
              }}
            />
          </div>
        )
      },
    },
    {
      title: '操作',
      key: 'actions',
      width: '6rem',
      align: 'center',
      render: function UserSettings(_, u): ReactElement {
        return (
          <>
            <a
              onClick={() => onClick('edit', u)}
              style={{ marginRight: '4px' }}
            >
              编辑
            </a>
          </>
        )
      },
    },
  ]
}
